import { Directive, ElementRef } from '@angular/core'
import { selectContents } from './autoselect.directive'

export const preselect = () => ({
  restrict: 'A',
  link (_$scope, element) {
    setTimeout(() => selectContents(element))
  },
})

@Directive({
  selector: '[preselect]',
})
export class PreselectDirective {
  constructor (private element: ElementRef<HTMLInputElement|HTMLTextAreaElement>) { }

  ngAfterViewInit () {
    setTimeout(() => {
      selectContents(this.element.nativeElement)
    })
  }
}
